import React, { useEffect, useRef } from 'react';
import {PCA} from 'ml-pca';
// import { Chart } from 'react-chartjs-2';
import { dot } from 'mathjs';
import { Chart, ScatterController, PointElement, LinearScale, Tooltip } from 'chart.js';
Chart.register(ScatterController, PointElement, LinearScale, Tooltip);


export interface MyComponentProps {
  // Define your prop types here
  data: any,
  lookupHash: any
  yValuesDateHash?: any
}


export const PCAChart: React.FC<MyComponentProps> = ({ data, lookupHash, yValuesDateHash }) => {
// const PCAChart = ({ data, lookupHash }) => {
  console.log("pca prop data", data)
  console.log("pca prop yValuesDateHash", yValuesDateHash)
  const chartRef = useRef<HTMLCanvasElement>(null);
  function standardize(data: any) {
    const mean = data.reduce((a: number, b: number) => a + b) / data.length;
    const stdDev = Math.sqrt(data.map((x: number) => Math.pow(x - mean, 2)).reduce((a: number, b: number) => a + b) / data.length);
    return data.map((x: number) => (x - mean) / stdDev);
  }


  const getColor = (datesHash: any) => {
    if (datesHash === undefined || Object.keys(datesHash).length === 0) {
      return
    }
    else {
      const dates = Object.values(datesHash).map((item: any) => new Date(item).getTime());
      const minDate = Math.min(...dates);
      const maxDate = Math.max(...dates);
      const getColorByDate = (date: number) => {
        const t = (date - minDate) / (maxDate - minDate || 1);
        const hue = 240 - 240 * t; // 240 (blue) to 0 (red)
        return `hsl(${hue}, 100%, 50%)`;
      }
      const pointColors = dates.map(getColorByDate);
      return pointColors;
    }
  }


  useEffect(() => {
    const pca: any = new PCA(data.map(standardize));
    //console.log(pca.getExplainedVariance());

    // Get the two first principal components
    const pc: any = pca.getEigenvectors();
    // console.log("pc", pc.data); // should print the number of elements in pc2
    // console.log(data[0]); // should print the number of elements in the first data point
    // Prepare the data for the chart

    
    const pointColors = getColor(yValuesDateHash);
    // console.log("pointColors", pointColors);

    if (chartRef.current) {
      const ctx: any = chartRef.current.getContext('2d');
      const chart = new Chart(ctx, {
        type: 'scatter',
        data: {
          datasets: [{
            label: 'PCA',
            data: data.map((d: any,index: number) => ({
              x: dot(pc.data.map((i: any[]) => i[0]), d),
              y: dot(pc.data.map((i: any[]) => i[1]), d),
              index: index,
            })),
            //backgroundColor: 'rgba(0,0,0,1)', // Change this to a darker color
            backgroundColor: pointColors || 'rgba(0,0,0,1)', // Use the pointColors array if available
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            x: {
              type: 'linear',
            },
            y: {
              type: 'linear',
            },
          },
          
          plugins: {
            tooltip: {
              callbacks: {
                // title: function(context) {
                //   const index = context[0].raw.index;
                //   // return 'Data Point: ' + index;
                //   return Object.keys(lookupHash)[index]
                // },
                label: function(context) {
                  const value: any = context.raw;
                  return  Object.keys(lookupHash)[value.index];
                }
              }
            }
          }
        },
      });
      return () => chart.destroy();
    }
  }, [data]);

  return (
    <canvas ref={chartRef}/>
  );
};